import React from 'react';

const Experience = () => {
  console.log("Experience component rendering with ID: experience");
  
  // Log the component's content for debugging
  const experienceContent = (
    <section id="experience" className="section activities">
      <h1 className="title">Experience & Education</h1>
      <div className="list">
        <div className="card item">
          <div className="name">IT / IOT Project Manager <span className="fade">at</span> Neo Advertising</div>
          <div className="period">
            <span className="date">2023</span>
            <span className="arrow">→</span>
            <span className="date">Present</span>
          </div>
          <p className="role-description">Managing IT infrastructure and IoT projects, ensuring seamless deployment and operation of digital advertising solutions.</p>
        </div>
        
        <div className="card item">
          <div className="name">Fivem Developer</div>
          <div className="period">
            <span className="date">2019</span>
            <span className="arrow">→</span>
            <span className="date">2023</span>
          </div>
          <p className="role-description">Developed custom scripts and modifications for Fivem platform, creating immersive multiplayer experiences.</p>
        </div>
        
        <div className="card item">
          <div className="name">DAM <span className="fade">at</span> IFP</div>
          <div className="period">
            <span className="date">2022</span>
            <span className="arrow">→</span>
            <span className="date">2023</span>
          </div>
          <p className="role-description">Application Development and Management studies, focusing on modern development methodologies and practices.</p>
        </div>
        
        <div className="card item">
          <div className="name">SMX <span className="fade">at</span> IFP </div>
          <div className="period">
            <span className="date">2019</span>
            <span className="arrow">→</span>
            <span className="date">2021</span>
          </div>
          <p className="role-description">Systems Microcomputer Networks, learning the fundamentals of IT infrastructure and networking.</p>
        </div>
      </div>
    </section>
  );
  
  console.log("Experience content:", experienceContent);
  
  return experienceContent;
};

export default Experience; 